import { M19Route } from "@m19-board/utils/M19Route";
import { StrategyPageSbCreativesComponent } from "@m19-board/strategies/strategy-page/strategy-page-sb-creatives/strategy-page-sb-creatives.component";
import { StrategyPageDspAudiencesComponent } from "@m19-board/strategies/strategy-page/strategy-page-dsp-audiences/strategy-page-dsp-audiences.component";
import { StrategyPageSdTargetingsComponent } from "@m19-board/strategies/strategy-page/strategy-page-sd-targetings/strategy-page-sd-targetings.component";
import { StrategyPageTacticsComponent } from "@m19-board/strategies/strategy-page/strategy-page-tactics/strategy-page-tactics.component";
import { StrategyPageDspCreativesComponent } from "@m19-board/dsp/dsp-creatives/strategy-page-dsp-creatives.component";
import { StrategyPageAdvancedSettingsComponent } from "@m19-board/strategies/strategy-page/strategy-page-advanced-settings/strategy-page-advanced-settings.component";
import { StrategyPageTargetingStatsComponent } from "@m19-board/strategies/strategy-page/strategy-page-targeting-stats/strategy-page-targeting-stats.component";
import { StrategyPageStatsComponent } from "@m19-board/strategies/strategy-page/strategy-page-stats/strategy-page-stats.component";
import { StrategyPageActivitiesComponent } from "@m19-board/strategies/strategy-page/strategy-page-activities/strategy-page-activities.component";
import { CampaignType } from "@front/m19-api-client";
import { StrategyPageComponent } from "@m19-board/strategies/strategy-page/strategy-page.component";
import { DspSupplyComponent } from "@m19-board/dsp/dsp-supply/dsp-supply.component";
import { StrategyPageResolver } from "@m19-board/strategies/strategy-page/strategy-page.resolver";
import { StrategyPageAudienceStatsComponent } from "./strategy-page-audience-stats/strategy-page-audience-stats.component";
import { StrategyPageBusinessStatsComponent } from "./strategy-page-business-stats/strategy-page-business-stats.component";
import { StrategyAsinsComponent } from "@m19-board/sponsored-product/sp-page/strategy-asins/strategy-asins.component";

export function getStrategyPageRoutes(
  campaignType: CampaignType,
  parentTitle: string,
  parentRouteUrl: string,
  strategyResolver: StrategyPageResolver,
): M19Route[] {
  return [
    {
      path: "",
      component: StrategyPageComponent,
      resolve: {
        strategy: strategyResolver,
      },
      data: {
        parentTitle,
        parentRouteUrl,
        subPage: true,
        withDatePicker: true,
        withCurrencySelector: true,
      },
      children: [
        {
          path: "products",
          component: StrategyAsinsComponent,
        },
        {
          path: "ad-lines",
          component: StrategyPageSbCreativesComponent,
        },
        {
          path: "audiences",
          component: StrategyPageDspAudiencesComponent,
        },
        {
          path: "targetings",
          component: StrategyPageSdTargetingsComponent,
        },
        {
          path: "tactics",
          component: StrategyPageTacticsComponent,
        },

        {
          path: "advanced-settings",
          component: StrategyPageAdvancedSettingsComponent,
        },
        {
          path: "targeting-stats",
          component: StrategyPageTargetingStatsComponent,
        },
        {
          path: "stats",
          component: StrategyPageStatsComponent,
        },
        {
          path: "audience-stats",
          component: StrategyPageAudienceStatsComponent,
        },
        {
          path: "business-stats",
          component: StrategyPageBusinessStatsComponent,
        },
        {
          path: "creatives",
          component: StrategyPageDspCreativesComponent,
        },
        {
          path: "activities",
          component: StrategyPageActivitiesComponent,
        },
        {
          path: "products",
          component: StrategyAsinsComponent,
        },
        {
          path: "supply",
          component: DspSupplyComponent,
        },
        {
          path: "**",
          redirectTo: campaignType === CampaignType.SB ? "ad-lines" : "products",
        },
      ],
    },
  ];
}
